'use client';

import { getNodesFromConnection } from '@graphql/connections/getNodesFromConnection';
import styles from './HeaderSection.module.css';
import { Container } from '../../../../components/Container/Container';
import { HeaderImage } from './components/HeaderImage';
import { SpeciesCatchWithImageNodeFields, SpeciesExampleCatchFields } from '@/generated/graphql';

interface IProps {
  catchCount: number;
  numberOfNewCatches: number;
  displayName: string;
  catches: (SpeciesExampleCatchFields | SpeciesCatchWithImageNodeFields)[];
  speciesId: string;
}

export const NR_OF_CATCHES_TO_SHOW = 7;

export const HeaderSection = ({
  catchCount,
  numberOfNewCatches,
  displayName,
  catches,
  speciesId,
}: IProps) => {
  return (
    <Container className="relative size-full p-0 sm:pt-6">
      <div
        className={`grid grid-flow-col gap-0.5 overflow-hidden sm:mx-0 sm:gap-1 ${styles.catchImagesGrid} sm:rounded-2xl`}
      >
        {catches.slice(0, NR_OF_CATCHES_TO_SHOW).map(({ post }) => {
          const image = getNodesFromConnection(post.images)[0];
          const imageUrl = image?.url ?? '';
          const imageWidth = image?.width ?? 0;
          const imageHeight = image?.height ?? 0;
          return (
            <HeaderImage
              key={post._id}
              catchCount={catchCount}
              imageHeight={imageHeight}
              imageUrl={imageUrl}
              imageWidth={imageWidth}
              isNewCatch={false}
              numberOfNewCatches={numberOfNewCatches}
              postId={post._id}
              speciesId={speciesId}
              speciesName={displayName}
            />
          );
        })}
      </div>
    </Container>
  );
};
